import React, { ReactElement, useState } from 'react'
import { useIntl } from 'react-intl'
import { getConfig } from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import { DHLPackstationMap, CustomLinkComponent, Input } from 'msp-components'
import { JasminDhlPackstationProps } from './JasminDhlPackstation.types'

const packstationIcon =
  encodeURIComponent(`<svg width="35" height="43" viewBox="0 0 47 58" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M47 23.5C47 36.4787 27.5 58 23.5 58C19.5 58 0 36.4787 0 23.5C0 10.5213 10.5213 0 23.5 0C36.4787 0 47 10.5213 47 23.5Z" fill="black" stroke="white" stroke-miterlimit="10"/>
<path d="M24 9.80072L12.996 16.0181V27.8877L24 34.2464L35.004 27.8877V16.0181L24 9.80072Z" stroke="white" stroke-miterlimit="10"/>
<path d="M18.984 12.8623L30.024 19.115" stroke="white" stroke-miterlimit="10"/>
<path d="M35.004 16.0181L24 22.3768L12.996 16.0181" stroke="white" stroke-miterlimit="10"/>
<path d="M24 22.3768V33.952" stroke="white" stroke-miterlimit="10"/>
</svg>`)

const JasminDhlPackstation = ({
  className,
  onPackstationSelect
}: JasminDhlPackstationProps) => {
  const { formatMessage } = useIntl()
  const [infoView, setInfoView] = useState<ReactElement>()
  const { externalIntegrations } = getConfig()

  const handleInfoViewSelect = (packstation: object) => {
    onPackstationSelect && onPackstationSelect(packstation)
    setInfoView(null)
  }

  const getInfoView = (packstation: object) => {
    return (
      <div className={'font-Roboto text-12 flex flex-col px-4 py-2'}>
        <div className={'flex flex-row space-x-6 pb-2'}>
          <div className={'font-Roboto font-bold'}>{`${
            packstation.packstationKeyword ||
            packstation.name ||
            packstation.streetAddress
          } ${packstation.packstationNumber}`}</div>
          <div>{`${packstation.distance} m`}</div>
        </div>

        <div>{packstation.name}</div>
        <div>{packstation.streetAddress}</div>
        <div>{`${packstation.postalCode} ${packstation.city}`}</div>
        {packstation.type === 'locker' && (
          <div className={'font-Roboto font-bold'}>
            {formatMessage({
              defaultMessage: 'Type: Packstation (locker)',
              id: 'msp.dhl_packstation_map.infoview.packstation_type_label'
            })}
          </div>
        )}
        <div
          className={'self-center pt-4'}
          onClick={() => handleInfoViewSelect(packstation)}
        >
          <CustomLinkComponent
            inline={true}
            className={'font-Roboto text-darkGray font-bold'}
          >
            {formatMessage({
              defaultMessage: 'Select packstation',
              id: 'msp.dhl_packstation_map.infoview.select_packstation'
            })}
          </CustomLinkComponent>
        </div>
      </div>
    )
  }

  const handlePackstationSelect = (packstation: object) => {
    const info = getInfoView(packstation)

    setInfoView(info)
    onPackstationSelect && (() => onPackstationSelect(packstation))
  }

  return (
    <DHLPackstationMap
      className={`mb-4 h-72 w-full md:h-80 ${className}`}
      DHLApiKey={externalIntegrations.DHLAPIKey}
      DHLApiUrl={externalIntegrations.DHLAPIUrl}
      GoogleMapApiKey={externalIntegrations.googleMapsAPIKey}
      packstationIcon={packstationIcon}
      onPackstationSelect={handlePackstationSelect}
      addressFinderInput={
        <Input
          className={'w-full md:w-[300px]'}
          placeholder={formatMessage({
            id: 'msp.dhl_packstation_map.search_input_placeholder',
            defaultMessage: 'Search for a location...'
          })}
        />
      }
      infoView={infoView}
      defaultDHLParams={{
        latitude: 51.1657,
        longitude: 10.4515,
        limit: 7,
        radius: 20000, //20Km
        locationType: ['postoffice', 'locker']
      }}
    />
  )
}

export default JasminDhlPackstation
